<template>
    <v-card>
        <v-dialog @keydown.esc="closeDialog" v-model="dialog" fullscreen transition="dialog-bottom-transition" overlay="false">
            <v-card>
                <v-toolbar color="primary" dark class="dialog-toolbar mb-6">
                    <v-btn data-cy="closeMedia" icon @click.native="closeDialog" dark>
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click.native="closeDialog">Select</v-btn>
                        <v-btn dark text @click.native="refreshLibrary">Refresh</v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <v-tabs v-model="active_tab" background-color="deep-purple accent-4" centered dark icons-and-text>
                        <v-tab href="#tab-1">
                            {{ $t('message.upload') }}
                            <v-icon>mdi-cloud-upload</v-icon>
                        </v-tab>

                        <v-tab href="#tab-2">
                            {{ $t('message.library') }}
                            <v-icon data-cy="MediaLibrary">mdi-heart</v-icon>
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="active_tab">
                        <v-tab-item value="tab-1">
                            <v-card flat>
                                <template>
                                    <v-form class="add-blog-form justify-space-between">
                                        <v-select
                                            hide-details
                                            v-bind:items="libraries"
                                            v-model="library"
                                            :label="$t('message.library')"
                                            class="input-group--focused librarySelect"
                                            item-text="title"
                                            item-value="id"
                                        ></v-select>
                                        <dropzone @vdropzone-success="vsuccess" v-on:vdropzone-sending="sendingEvent" id="myVueDropzone" class="mb-2" :options="dropzoneOptions"> </dropzone>
                                    </v-form>
                                </template>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item value="tab-2">
                            <v-card flat v-if="blocks && blocks.length" style="background: #6200ea">
                                <div origin-left="false" transition-duration="1s" item-selector=".item">
                                    <v-layout wrap>
                                        <div xs3 class="item" v-for="(item, index) in blocks" :key="index">
                                            <v-icon class="removeImg" medium color="red" @click="onDelete(item, index)"> delete </v-icon>
                                            <img
                                                :data-cy="item.id"
                                                :id="item.id"
                                                :src="item.path"
                                                width="200"
                                                @error="fixImg"
                                                :mime="item.type"
                                                @click="myFilter(item)"
                                                :class="selected.includes(item.id) ? 'active' : ''"
                                            />
                                            <label>{{ item.title }}</label>
                                        </div>
                                    </v-layout>
                                </div>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card-text>
                <delete-confirmation-dialog
                    ref="deleteConfirmationDialog"
                    heading="Are You Sure You Want To Delete?"
                    message="Are you sure you want to delete this permanently?"
                    @onConfirm="deleteItem"
                >
                </delete-confirmation-dialog>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<style scoped>
.removeImg {
    position: absolute;
    right: 6px;
    top: 0;
    background: white;
    border-radius: 50%;
    padding: 2px;
}
.menuable__content__active {
    z-index: 250 !important;
}
.librarySelect {
    margin: 30px auto;
    display: block;
}
img.active {
    border: 2px solid #5d92f4;
}
img {
    margin-bottom: 0;
    margin-top: 5px;
}
label {
    position: absolute;
    bottom: 5px;
    color: white;
    background: black;
    width: 100%;
    right: 0;
    text-align: center;
    max-height: 46px;
    overflow: hidden;
    line-height: 16px;
}
.item {
    position: relative;
}
img[mime='video/mp4'],
img[mime='application/pdf'] {
    max-width: 150px;
}
</style>
<script>
import { mapGetters } from 'vuex'
import Dropzone from 'vue2-dropzone'
import Api, { ApiURL } from 'Api'
import AppConfig from 'Constants/AppConfig.js'

export default {
    components: {
        Dropzone
    },
    props: ['IDs', 'dialog', 'selected', 'multiple'],
    data() {
        return {
            blocks: [],
            newUploads: false,
            libraries: [],
            library: null,
            dropzoneOptions: {
                url: AppConfig.API_URL + ApiURL.mediaUpload,
                thumbnailWidth: 150,
                maxFilesize: 15,
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            },
            active_tab: null
        }
    },
    computed: {
        ...mapGetters(['media'])
    },
    mounted() {
        this.getLibraries()
        this.blocks = this.media ? this.media.data : []
    },
    created() {
        this.$store.dispatch('getMediaFiles', true)
    },
    watch: {
        IDs: function () {
            let ids = this.IDs.filter((value, index) => {
                return this.IDs.indexOf(value) === index
            })
            let _ids = this.media.data.map((m) => {
                if (ids.indexOf(m.id) > -1) {
                    return m.id
                }
            })
            ids = ids.filter((id) => {
                return _ids.indexOf(id) < 0
            })
            if (ids.length > 0) {
                this.$store.dispatch('getIDsToMedia', ids)
            }
        },
        media: function () {
            this.blocks = this.media.data.map((item) => {
                item.path = item.path
                return item
            })
        },
        active_tab: function () {
            if (this.active_tab == 'tab-2') {
                setTimeout(() => {
                    if (this.blocks.length > 0 && typeof this.$redrawVueMasonry === 'function') this.$redrawVueMasonry()
                }, 500)
            }
        }
    },
    methods: {
        vsuccess(file, response) {
            this.$store.dispatch('PushToMediaFiles', response)
            this.refreshLibrary()
        },
        closeDialog() {
            this.$emit('update:dialog', false)
        },
        sendingEvent(file, xhr, formData) {
            this.newUploads = true
            formData.append('library', this.library)
            formData.append('_token', document.querySelector('meta[name="csrf-token"]').getAttribute('content'))
        },
        getLibraries() {
            Api.get(ApiURL.mediaLibrary)
                .then((res) => {
                    this.libraries = res.data.data
                    let defaultLibrary = this.libraries.filter((lib) => {
                        return lib.default == 1
                    })[0]

                    if (defaultLibrary && defaultLibrary.id) this.library = defaultLibrary.id
                })
                .catch((err) => console.log(err))
        },
        myFilter(item) {
            let id = item.id
            let theSelected = []
            let _selectedObj = []
            if (this.multiple) {
                theSelected = this.selected.includes(id)
                    ? this.selected.filter((i) => {
                          return i !== id
                      })
                    : [...this.selected, id]
                _selectedObj = this.selected.includes(id)
                    ? this.selected.filter((i) => {
                          return i !== id
                      })
                    : [...this.selectedObj, item]
            } else {
                theSelected = this.selected.includes(id) ? [] : [id]
                _selectedObj = this.selected.includes(id) ? [] : [item]
            }

            this.$emit('update:selected', theSelected)
            this.$emit('update:selectedObj', _selectedObj)
        },
        refreshLibrary() {
            let theMedia = this.$store.getters.media.data
            this.blocks = theMedia
            if (this.blocks.length > 0 && typeof this.$redrawVueMasonry === 'function') this.$redrawVueMasonry()
        },

        onDelete(item, index) {
            this.$refs.deleteConfirmationDialog.openDialog()
            this.selectItemToDelete = { item, index }
        },

        deleteItem() {
            this.$refs.deleteConfirmationDialog.close()
            let { item, index } = this.selectItemToDelete
            this.loader = true

            Api.delete('/media/remove/' + item.id)
                .then((res) => {
                    this.blocks.splice(index, 1)
                    this.loader = false
                })
                .catch((err) => console.log(err))
        }
    }
}
</script>
